import { useCartContext } from "@/context/cart"
import { MiniCartFragment } from "@/hooks/MiniCart/miniCartFragments.gql"
import { gql, useQuery } from "@apollo/client"
import { ExtendedCart } from "./new-minicart"

export const MINI_CART_QUERY = gql`
  query MiniCartQueryNew($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      ...MiniCartFragment
    }
  }
  ${MiniCartFragment}
`

export const useMiniCartData = ({ open }: { open: boolean }) => {
  const [{ cartId }] = useCartContext()

  const {
    data: miniCartData,
    loading: miniCartLoading,
    refetch,
  } = useQuery<{ cart: ExtendedCart }>(MINI_CART_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: {
      cartId,
    },
    skip: !cartId || !open,
    errorPolicy: "all",
  })

  const grandTotal = miniCartData?.cart?.prices?.grand_total

  const productList = miniCartData?.cart?.items || []

  const total_quantity = miniCartData?.cart?.total_quantity ?? 0

  return {
    refetch,
    miniCartData,
    miniCartLoading,
    grandTotal,
    productList,
    total_quantity,
  }
}
